"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PER_PAGES = exports.SORTABLES = void 0;
var i18n_1 = __importDefault(require("@/react-app/i18n"));
exports.SORTABLES = [
    {
        id: '1',
        label: i18n_1.default.t('SEARCH.HEADER.NEWEST'),
        order: 'DESC',
        sortBy: 'metadata.created',
    },
    {
        id: '2',
        label: i18n_1.default.t('SEARCH.HEADER.OLDEST'),
        order: 'ASC',
        sortBy: 'metadata.created',
    },
    {
        id: '3',
        label: i18n_1.default.t('SEARCH.HEADER.MOST_RELEVANT'),
        order: 'DESC',
        sortBy: 'score',
    },
];
exports.PER_PAGES = [
    {
        id: 10,
        label: 10,
    },
    { id: 20, label: 20 },
    { id: 30, label: 30 },
    { id: 40, label: 40 },
    { id: 50, label: 50 },
    { id: 100, label: 100 },
];
